module.exports = __webpack_public_path__ + "img/address.a9015f1a.png";